import { Dispatch } from "redux";
import { createActionCreator, createReducer } from "deox";
import * as pageSettingsService from "../services/pageSettings";
import { PageSettings } from "../models/misc";

export type State = {
  data: PageSettings | null;
  all:  PageSettings[] | null;
};

const defaultState: State = {
  data: null,
  all:  null,
};

const fetchPageSettings = Object.assign(
  (pageName: string) => async (dispatch: Dispatch) => {
    try {
      const result = await pageSettingsService.getPageSettings(pageName);
      dispatch(fetchPageSettings.success(result));
    } catch {
      return;
    }
  },
  {
    success: createActionCreator(
      "@@PAGESETTINGS/FETCH",
      resolve => (data: PageSettings) => resolve(data)
    ),
  }
);

const fetchAllPageSettings = Object.assign(
    () => async (dispatch: Dispatch) => {
      try {
        const result = await pageSettingsService.getAllPageSettings();
        dispatch(fetchAllPageSettings.success(result));
      } catch {
        return;
      }
    },
    {
      success: createActionCreator(
        "@@PAGESETTINGS/ALL_FETCH",
        resolve => (data: PageSettings[]) => resolve(data)
      ),
    }
  );

  const createPageSettings = (pageName: string) => async (dispatch: any) => {
    try {
      await pageSettingsService.createPageSettings(pageName);
      dispatch(fetchAllPageSettings());
    } catch {
        return;
    }
  };

  const deletePageSettings = (pageName: string) => async (dispatch: any) => {
    try {
      await pageSettingsService.deletePageSettings(pageName);
      dispatch(fetchAllPageSettings());
    } catch {
    }
  };

  const updatePageSettings = (settings: PageSettings) => async (dispatch: any) => {
    try {
      await pageSettingsService.updatePageSettings(settings);
      dispatch(fetchAllPageSettings());
    } catch {}
  };

const reducer = createReducer(defaultState, handleAction => [
  handleAction(fetchPageSettings.success, (state, action) => ({
    ...state,
    data: action.payload,
  })),
  handleAction(fetchAllPageSettings.success, (state, action) => ({
    ...state,
    all: action.payload,
  })),
]);

const actions = {
  fetchPageSettings,
  fetchAllPageSettings,
  createPageSettings,
  deletePageSettings,
  updatePageSettings,
};

export { actions, reducer };
